import { Box, Divider, Grid, Typography } from '@material-ui/core';
import React, { useMemo } from 'react';
import { moneyFormat } from 'src/utils/Common';

export function Cost({
    workOrderLabours,
    workOrderMaterials,
    workOrderTransport,
    workOrderExtra,
    currency,
    tenantCode
}) {

    const cost = useMemo(() => {
        let labourSum = 0,
            LabourVatSum = 0;
        for (const item of workOrderLabours) {
            labourSum += item.LabourPrice;
            LabourVatSum += item.LabourPriceWithWat - item.LabourPrice;
        }

        let materialSum = 0,
            MaterialVatSum = 0;
        for (const item of workOrderMaterials) {
            const totalPrice = item.MaterialPrice * item.Count;
            const totalVat = (item.MaterialPriceWithWat - item.MaterialPrice) * item.Count;
            materialSum += totalPrice;
            MaterialVatSum += totalVat;
        }

        let transportSum = 0,
            TransportVatSum = 0;
        for (const item of workOrderTransport) {
            const totalPrice = item.MaterialPrice;
            const totalVat = item.MaterialPriceWithWat - item.MaterialPrice;
            transportSum += totalPrice;
            TransportVatSum += totalVat;
        }

        let extraSum = 0,
            ExtraVatSum = 0;
        for (const item of workOrderExtra) {
            const totalPrice = item.MaterialPrice;
            const totalVat = item.MaterialPriceWithWat - item.MaterialPrice;
            extraSum += totalPrice;
            ExtraVatSum += totalVat;
        }

        const subTotal = labourSum + materialSum + transportSum + extraSum;
        const vatTotal = LabourVatSum + MaterialVatSum + TransportVatSum + ExtraVatSum;
        const total = subTotal + vatTotal;

        return {
            labourSum,
            materialSum,
            transportSum,
            extraSum,
            subTotal,
            vatTotal,
            total
        };
    }, [workOrderLabours, workOrderMaterials, workOrderTransport, workOrderExtra]);

    const rows = [
        { label: 'Labour Total', value: cost.labourSum, currency },
        { label: 'Material Total', value: cost.materialSum, currency },
        { label: 'Transportation Total', value: cost.transportSum, currency },
        { label: 'Extra Total', value: cost.extraSum, currency },
        'divider',
        { label: 'Sub Total', value: cost.subTotal, currency, color: 'error' },
        { label: 'Vat', value: cost.vatTotal, currency, color: 'error' },
        { label: 'Total', value: cost.total, currency, color: 'error' }
    ];

    return (
        <Box p={2}>
            <Grid container spacing={1}>
                {rows.map((row, idx) =>
                    row === 'divider' ? (
                        <Grid item xs={12} key={`divider-${idx}`}>
                            <Divider />
                        </Grid>
                    ) : (
                        <Grid container item key={row.label}>
                            <Grid item xs={6}>
                                <Typography variant="body1" color={row.color || 'textSecondary'} align="right">
                                    {row.label}
                                </Typography>
                            </Grid>
                            <Grid item xs={4}>
                                <Typography variant="h6" align="right" color={row.color}>
                                    {moneyFormat(row.value, tenantCode, currency)}
                                </Typography>
                            </Grid>
                            <Grid item xs={2}>
                                <Typography variant="h6" align="center" color={row.color}>
                                    {row.currency}
                                </Typography>
                            </Grid>
                        </Grid>
                    )
                )}
            </Grid>
        </Box>
    );
}
